import Axios from 'axios';
import { UrlBase, URL_PLUGIN } from '../parametros';
import { onCatch, onThen } from './utils';

export const guardarLead = async (idCotizacion, accion, paramsUrl = "") => {

  const {
    default: { getState },
  } = await import('src/store');
  const { flujoPlugin = "0" } = getState()?.Cotizacion?.cotizacion;
  // const { Cotizacion={} } = getState();
  // const {flujoPlugin= } = Cotizacion?.cotizacion
  const lead = {
    leadCotizacionId: idCotizacion,
    accion,
    url: `${window.location.href}${paramsUrl}`,
    flujo: +flujoPlugin
  };
  return await Axios.post(`${URL_PLUGIN}agregar-lead`, JSON.stringify(lead))
    .then((data) => data)
    .catch(onCatch);
};

export const guardarInfoFinaciero = async () => {
  const {
    default: { getState },
  } = await import('src/store');
  const { cotizacion } = getState()['Cotizacion'];
  const { empCodigo } = cotizacion.producto;
  const { titular, infoTransaccion } = cotizacion;

  if (infoTransaccion && titular) {
    guardarLead(cotizacion.idCotizacion, `GUARDO_INFO_FINANCIERO`);

    const URL = `${UrlBase}frontend/web/index.php?r=site/guardar-informacion-seguro&empresa=${empCodigo}&plataforma=WEB&cedula=${titular.identificacion}&codigoCore=${infoTransaccion.codigoSocio}&idCotizacion=${cotizacion.idCotizacion}`;
    const response = await Axios.get(URL).then(onThen).catch(onCatch);
    console.log(response);
  }
};

export const notificarFinCompra = async (idCotizacion) => {
  const URL = `${URL_PLUGIN}notifica-fin-compra`;
  return await Axios.post(URL, JSON.stringify({ idCotizacion })).then(onThen).catch(onCatch);
};

export const login = async (body) => {
  const URL = `${URL_PLUGIN}iniciar-sesion-plugin`;
  return await Axios.post(URL, JSON.stringify(body)).then(onThen).catch(onCatch);
};

//actionFirmarPolizaEvicertia
export const firmarDocumentosEV = (body) =>
  Axios.post(`${URL_PLUGIN}firmar-documentos-evicertia`, JSON.stringify(body))
    .then(onThen)
    .catch(onCatch);

export const guardarLog = (body) => {
  Axios.post(`${URL_PLUGIN}generar-log`, JSON.stringify(body))
    .then((result) => result)
    .catch((err) => console.log('ERROR AL GUARDAR LOG'));
};

export const guardarLeadPoliza = (idPoliza, accion) => Axios.post(
  `${UrlBase}frontend/web/index.php?r=plugin/poliza/save-lead`,
  JSON.stringify({
    accion,
    idPoliza,
    url: window.location.href,
  })
).then((data) => data).catch(onCatch);

export const POST = (url: string, body = {}) => Axios.post(url, JSON.stringify(body)).then(result => {
  if (result.status === 200) {
    const { data } = result;
    if (data.transaccion && data.transaccion === true) {
      return data;
    } else {
      //TODO hace un standar para peticiones
      return { error: true, data };
    }
  }
}).catch(error => {
  return { error: true, descripcion: 'Error al consumir el servicio' };
})

export const GET = (url: string) => Axios.get(url).then(result => {
  if (result.status === 200) {
    const { data } = result;
    if (data.transaccion && data.transaccion === true) {
      return data;
    } else {
      //TODO hace un standar para peticiones
      return { error: true, data };
    }
  }
}).catch(error => {
  return { error: true, descripcion: 'Error al consumir el servicio' };
})



